/**
 * Transform Yoast FAQ blocks into accordions.
 */
const initFAQ = () => {
	const FaqBlocks = document.querySelectorAll('.wp-block-yoast-faq-block');

	FaqBlocks.forEach((faqBlock) => {
		const sections = faqBlock.querySelectorAll('.schema-faq-section');

		sections.forEach((section) => {
			const question = section.querySelector('.schema-faq-question');
			const answer = section.querySelector('.schema-faq-answer');
			const sectionID = section.getAttribute('id');

			const button = document.createElement('button');
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-controls', `${sectionID}-content`);
			button.setAttribute('id', `${sectionID}-question`);
			button.classList.add('wp-block-yoast-faq-block__question');
			button.appendChild(question);
			section.insertBefore(button, section.firstChild);

			const content = document.createElement('div');
			const contentBody = document.createElement('div');
			contentBody.classList.add('wp-block-yoast-faq-block__content__body');
			content.setAttribute('id', `${sectionID}-content`);
			content.setAttribute('aria-labelledby', `${sectionID}-question`);
			content.setAttribute('aria-hidden', true);
			content.classList.add('wp-block-yoast-faq-block__content');
			contentBody.appendChild(answer);
			content.appendChild(contentBody);

			section.appendChild(content);

			button.addEventListener('click', () => {
				const isExpanded = button.getAttribute('aria-expanded') === 'true';

				// Close all other sections
				sections.forEach((otherSection) => {
					if (otherSection !== section) {
						const otherButton = otherSection.querySelector('button');
						const otherContent = otherSection.querySelector(
							'.wp-block-yoast-faq-block__content',
						);
						otherButton.setAttribute('aria-expanded', 'false');
						otherContent.setAttribute('aria-hidden', 'true');
					}
				});

				button.setAttribute('aria-expanded', !isExpanded);
				content.setAttribute('aria-hidden', isExpanded);
			});
		});
	});
};

export default initFAQ;
